import Report from '../../../model/Report'
import { deleteReport as apiDeleteReport, loadReportList } from '../../../rest-api/Report-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'

const actionCreator = actionCreatorFactory()

export const DeleteReport = actionCreator.async<
  { market: string; report: Report },
  Report[],
  string
>('DeleteReport')

const deleteReportWorker = wrapAsyncWorker(
  DeleteReport,
  (params: { market: string; report: Report }): Promise<Report[]> =>
    apiDeleteReport(params).then(() =>
      loadReportList({ market: params.market, reportGroup: params.report.reportGroup })
    )
)

// thunk action creator
export const deleteReport = (market: string, report: Report) => {
  return (dispatch: Dispatch<AnyAction>) => deleteReportWorker(dispatch, { market, report })
}
